import { useResponsive } from '../../../../hooks/useResponsive';

export const WrappedAxisTick = ({
  x,
  y,
  payload,
}: {
  x: number;
  y: number;
  payload: { value: string };
}) => {
  const { isMobile, isTablet, isLaptop } = useResponsive();

  const words = String(payload.value).split(' ');

  const wordsForCalc = words.filter((w) => w.length > 1);

  const firstLineCalcCount = Math.ceil(wordsForCalc.length / 2);

  let splitIndex = 0;
  let longCount = 0;
  for (let i = 0; i < words.length; i++) {
    if (words[i].length > 1) {
      longCount++;
    }
    if (longCount === firstLineCalcCount) {
      splitIndex = i + 1;
      break;
    }
  }

  const firstLine = words.slice(0, splitIndex).join(' ');
  const secondLine = words.slice(splitIndex).join(' ');

  return (
    <text x={x} y={y} textAnchor="middle" fontSize={isMobile ? 6 : isTablet ? 7 : isLaptop ? 8 : 9}>
      <tspan x={x} dy={0}>
        {firstLine}
      </tspan>
      <tspan x={x} dy={10}>
        {secondLine}
      </tspan>
    </text>
  );
};
